import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TabBar from "@/components/public/TabBar";
import AppCard from "@/components/public/AppCard";
export default {
  name: "OfficeServeList",
  components: {
    TabBar: TabBar,
    AppCard: AppCard
  },
  props: [],
  data: function data() {
    return {
      loading: false,
      tabIndex: "0",
      tabData: [{
        index: "0",
        name: "推荐"
      }, {
        index: "1",
        name: "学工"
      }, {
        index: "2",
        name: "人事"
      }, {
        index: "3",
        name: "收藏"
      }],
      list: []
    };
  },
  computed: {
    url: function url() {
      switch (this.tabIndex) {
        case "0":
          return "/hallServe/servePermitList";

        case "1":
          return "/hallServe/servePermitList";

        case "2":
          return "/hallServe/servePermitList";

        case "3":
          return "/personal/collection/getAllData";

        default:
          break;
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.fetchList();
  },
  destroyed: function destroyed() {},
  methods: {
    fetchList: function fetchList() {
      var _this = this;

      this.loading = true; // this.list = [];

      var sift = {};
      sift.pageNum = 1;
      sift.pageSize = 100;

      if (this.tabIndex == 0) {
        sift.recommend = 1;
      } else if (this.tabIndex == 1) {
        sift.serveSubject = "7984587f-c5e6-42ce-89e1-1376acdedebf";
      } else if (this.tabIndex == 2) {
        sift.serveSubject = "1ca3ac64-b06d-4ff7-8487-2b34ee069bd8";
      }

      if (this.tabIndex == 3) {
        this.$http.get(this.url, {
          params: sift
        }).then(function (_ref) {
          var data = _ref.data;

          if (data.resCode == 0) {
            _this.list = data.resData.list.map(function (val) {
              return {
                id: val.serveId,
                serveName: val.serveName,
                serveType: Number(val.serveType),
                serveTitle: val.serveTitle,
                appraise: val.score,
                favoriteCount: val.count,
                serveImage: val.processLogoDl,
                collection: val.serveCollect,
                interfaceUrl: val.interfaceUrl,
                linkUrl: val.interfaceUrl,
                // 新增所属部门列表字段
                deptName: val.deptNameIds ? val.deptNameIds.map(function (val) {
                  return val.deptName;
                }).join("、") : "-"
              };
            });
          }

          _this.loading = false;
        }).catch(function () {
          _this.loading = false;
        });
      } else {
        this.$http.post(this.url, this.$qs.stringify(sift)).then(function (_ref2) {
          var data = _ref2.data;

          if (data.resCode == 0) {
            _this.list = data.resData.list.map(function (val) {
              return {
                id: val.id,
                serveName: val.serveName,
                serveType: Number(val.serveType),
                serveTitle: _this.serveSubjectToString(val.serveSubjectList),
                appraise: val.commentScore,
                favoriteCount: val.storeCount,
                serveImage: val.logo,
                collection: val.serveCollect,
                interfaceUrl: val.interfaceUrl,
                linkUrl: val.linkUrl,
                // 新增所属部门列表字段
                deptName: val.deptNameIds ? val.deptNameIds.map(function (val) {
                  return val.deptName;
                }).join("、") : "-"
              };
            });
          }

          _this.loading = false;
        }).catch(function () {
          _this.loading = false;
        });
      }
    },
    serveSubjectToString: function serveSubjectToString(arr) {
      var newArr = arr.map(function (val) {
        return val.subjectName;
      });
      return newArr.join("、");
    },
    changeTabIndex: function changeTabIndex(index) {
      var _this2 = this;

      this.tabIndex = index;
      this.$nextTick(function () {
        _this2.fetchList();
      });
    }
  },
  watch: {
    tabIndex: function tabIndex() {
      this.fetchList();
    }
  },
  filters: {}
};